import { makeStyles } from '@griffel/react';

import { TextTransform } from '../fonts';

export type { TextTransform };

export const useTextTransformClassName = (textTransform?: TextTransform) => {
  const textTransformClassNames = useTextTransformClassNames();

  return textTransform ? textTransformClassNames[textTransform] : undefined;
};

const useTextTransformClassNames = makeStyles<TextTransform>({
  capitalize: {
    textTransform: 'capitalize',
  },
  lowercase: {
    textTransform: 'lowercase',
  },
  uppercase: {
    textTransform: 'uppercase',
  },
});
